// Pool sizing by quality tier and per-effect slot reservation (docs/ART-DIRECTION.md §7: particle caps
// ×0.4 / ×0.7 / ×1).

import { InvariantViolation } from '@taxwar/net'
import type { QualityTier } from '../render/visualSettings'

export const QUALITY_SCALE: Readonly<Record<QualityTier, number>> = { low: 0.4, medium: 0.7, high: 1 }

/** A High-tier count at `scale`, never below one. */
export function scaledCount(highCount: number, scale: number): number {
  return Math.max(1, Math.round(highCount * scale))
}

/**
 * A contiguous run of pool slots reserved for one effect. Claims go round-robin in spawn order, so the claimed slot
 * is either free or the effect's oldest live instance, which is recycled (max concurrent effects per kind).
 */
export class SlotRange {
  private cursor = 0

  constructor(
    readonly first: number,
    readonly count: number,
  ) {
    if (count < 1) throw new InvariantViolation(`slot range of ${count} slots`)
  }

  claim(): number {
    const slot = this.first + this.cursor
    this.cursor = (this.cursor + 1) % this.count
    return slot
  }
}
